<template>
    <div>
        <label :for="uuid" class="block mb-2 text-sm font-medium text-gray-900" v-if="label && label.length > 0">{{ label }}</label>
        <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" @change="changeValue">
            <option disabled value :selected="modelValue === '' || modelValue === -1">Please select an option</option>
            <option v-for="(option, key) in options" :value="key" :selected="key === modelValue" :key="option.value">{{ option }}</option>
        </select>
        <div class="text-red-500" v-if="fielderrors && fielderrors[name]">
            {{ fielderrors[name] }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        name: {},
        label: {},
        modelValue: {},
        options: {},
        fielderrors: {},
    },

    data() {
        return {
            uuid: this.generateUUID(),
        };
    },

    methods: {
        changeValue(e) {
            this.$emit('update:modelValue', e.target.value);
        }
    }
}
</script>